/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const PopUpBox = styled.div`
  width: auto;
  height: auto;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 16px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 0px 18px 0px rgba(23, 43, 77, 0.08), 0px 8px 24px 0px rgba(23, 43, 77, 0.08);
`;

export const FlexWrap = styled.div`
  display: flex;
  column-gap: 10px;
`;

export const ErrorWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: ${Palette.Red._600};
  padding: 8px 0;
  margin-bottom: 2px;
`;
